/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelstatussending2Inputs */

const en_channelstatussending2 = /** @type {(inputs: Channelstatussending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

const de_channelstatussending2 = /** @type {(inputs: Channelstatussending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Channelstatussending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelstatussending2 = /** @type {((inputs?: Channelstatussending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelstatussending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelstatussending2(inputs)
	return de_channelstatussending2(inputs)
});
export { channelstatussending2 as "channelStatusSending" }